import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetDripSequences as GetDripSequencesQuery,
    GetDripSequencesVariables as GetDripSequencesQueryVariables,
} from 'nutshell-graphql-types';

import GET_DRIP_SEQUENCES from '../queries/get-drip-sequences.graphql';

export const useGetDripSequences = (variables: GetDripSequencesQueryVariables) => {
    const {data, error, loading} = useQuery<GetDripSequencesQuery, GetDripSequencesQueryVariables>(
        GET_DRIP_SEQUENCES,
        {
            variables: variables,
            fetchPolicy: 'cache-and-network',
            notifyOnNetworkStatusChange: true,
        }
    );

    const dripSequencesData = data ? data.dripSequences : null;
    const dripSequences = dripSequencesData;

    return {
        dripSequences,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        loading,
    };
};
